import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function TableIcon({ className, size = 24, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path d="M5.5 2H4.66667C3.19391 2 2 3.19391 2 4.66667V5.5H5.5V2Z" fill="currentColor" />
      <path d="M2 6.5V9.5H5.5V6.5H2Z" fill="currentColor" />
      <path d="M2 10.5V11.3333C2 12.8061 3.19391 14 4.66667 14H5.5V10.5H2Z" fill="currentColor" />
      <path d="M6.5 14H9.5V10.5H6.5V14Z" fill="currentColor" />
      <path d="M10.5 14H11.3333C12.8061 14 14 12.8061 14 11.3333V10.5H10.5V14Z" fill="currentColor" />
      <path d="M14 9.5V6.5H10.5V9.5H14Z" fill="currentColor" />
      <path d="M14 5.5V4.66667C14 3.19391 12.8061 2 11.3333 2H10.5V5.5H14Z" fill="currentColor" />
      <path d="M9.5 2H6.5V5.5H9.5V2Z" fill="currentColor" />
      <path d="M9.5 9.5H6.5V6.5H9.5V9.5Z" fill="currentColor" />
    </svg>
  )
}
